type PropertyTypeIconProps = {
  fill?: string
  size?: number
}
export const AgriculturalIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props
  return (
    <svg width={size + (size * 1) / 5} height={size} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.6 4.64C19.28 2 17.12 0 14.4 0C13.04 0 11.68 0.56 10.72 1.52C10.16 2.08 9.75999 2.64 9.51999 3.36L14 6.32V6.4H16.4V8H14V9.6H16.4V11.2H14V12.8H16.4V14.4H14V16H19.6V4.64ZM11.04 4C11.52 2.56 12.88 1.6 14.4 1.6C15.92 1.6 17.28 2.56 17.76 4H11.04ZM0.399994 7.2V16H4.39999V10.4H8.39999V16H12.4V7.2L6.39999 3.2L0.399994 7.2Z"
        fill={fill}
      />
    </svg>
  )
}

export const EducationIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props

  return (
    <svg
      width={Math.ceil(size + size / 5)}
      height={size}
      viewBox="0 0 20 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0004 12.3073C9.89325 12.3073 9.78799 12.2793 9.69499 12.2261L4.30823 9.14739C4.26142 9.12036 4.20832 9.10614 4.15428 9.10616C4.10023 9.10618 4.04714 9.12044 4.00035 9.1475C3.95356 9.17456 3.91473 9.21346 3.88776 9.2603C3.86079 9.30714 3.84663 9.36025 3.84671 9.4143V12.3073C3.84661 12.4171 3.87592 12.525 3.93158 12.6197C3.98724 12.7143 4.06723 12.7924 4.16324 12.8457L9.70153 15.9226C9.79295 15.9734 9.89579 16 10.0004 16C10.1049 16 10.2078 15.9734 10.2992 15.9226L15.8375 12.8457C15.9335 12.7924 16.0135 12.7143 16.0692 12.6197C16.1248 12.525 16.1541 12.4171 16.154 12.3073V9.4143C16.1541 9.36025 16.1399 9.30714 16.113 9.2603C16.086 9.21346 16.0472 9.17456 16.0004 9.1475C15.9536 9.12044 15.9005 9.10618 15.8465 9.10616C15.7924 9.10614 15.7393 9.12036 15.6925 9.14739L10.3057 12.2261C10.2128 12.2793 10.1075 12.3073 10.0004 12.3073Z"
        fill={fill}
      />
      <path
        d="M19.2278 5.48057V5.47634C19.2178 5.3788 19.1847 5.28505 19.1312 5.20289C19.0777 5.12074 19.0053 5.05257 18.9201 5.00405L10.305 0.0811179C10.212 0.027961 10.1067 0 9.9996 0C9.89248 0 9.78722 0.027961 9.69422 0.0811179L1.0791 5.00405C0.984941 5.05788 0.906685 5.13564 0.852258 5.22946C0.797831 5.32327 0.769165 5.4298 0.769165 5.53826C0.769165 5.64672 0.797831 5.75325 0.852258 5.84707C0.906685 5.94088 0.984941 6.01864 1.0791 6.07248L9.69422 10.9954C9.78722 11.0486 9.89248 11.0765 9.9996 11.0765C10.1067 11.0765 10.212 11.0486 10.305 10.9954L17.8847 6.66438C17.8965 6.65762 17.9098 6.65406 17.9233 6.65408C17.9368 6.65409 17.9501 6.65767 17.9618 6.66446C17.9735 6.67125 17.9832 6.681 17.9899 6.69274C17.9967 6.70447 18.0002 6.71778 18.0001 6.7313V12.29C18.0001 12.6211 18.2547 12.9054 18.5859 12.9219C18.6691 12.9259 18.7522 12.913 18.8303 12.8839C18.9084 12.8548 18.9797 12.8102 19.04 12.7527C19.1003 12.6953 19.1483 12.6262 19.1811 12.5496C19.2139 12.473 19.2309 12.3906 19.2309 12.3073V5.53826C19.2308 5.51899 19.2298 5.49974 19.2278 5.48057Z"
        fill={fill}
      />
    </svg>
  )
}

export const IndustrialIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.6 12.8V14.4H4.8V12.8H1.6ZM1.6 9.6V11.2H9.6V9.6H1.6ZM6.4 12.8V14.4H9.6V12.8H6.4ZM11.2 9.6V11.2H14.4V9.6H11.2ZM11.2 12.8V14.4H14.4V12.8H11.2ZM0 16V4.8L4 8V4.8L8 8V4.8L12 8L12.8 0H15.2L16 8V16H0Z"
        fill={fill}
      />
    </svg>
  )
}

export const MedicalIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props
  return (
    <svg
      width={size + Math.ceil(size / 9)}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.625 3.5C2.0382 3.5 1.5625 3.97756 1.5625 4.56667V14.4339H7.9375V10.7005H10.0625V14.4339H16.4375V4.56667C16.4375 3.97756 15.9618 3.5 15.375 3.5H2.625ZM3.6875 5.90052H5.8125V8.03385H3.6875V5.90052ZM7.9375 5.90052H10.0625V8.03385H7.9375V5.90052ZM12.1875 5.90052H14.3125V8.03385H12.1875V5.90052ZM3.6875 10.1672H5.8125V12.3005H3.6875V10.1672ZM12.1875 10.1672H14.3125V12.3005H12.1875V10.1672Z"
        fill={fill}
      />
      <path
        d="M0.5 15.5C0.5 14.9109 0.975698 14.4339 1.5625 14.4339H16.4375C17.0243 14.4339 17.5 14.9109 17.5 15.5H0.5Z"
        fill={fill}
      />
      <path
        d="M8.58333 4.38889H9.41667V3.41667H10.3889V2.58333H9.41667V1.61111H8.58333V2.58333H7.61111V3.41667H8.58333V4.38889ZM6.5 5.5V1.5C6.5 0.947715 6.94772 0.5 7.5 0.5H10.5C11.0523 0.5 11.5 0.947715 11.5 1.5V5.5H6.5Z"
        fill={fill}
      />
      <path
        d="M9.41667 4.38889H8.58333V3.41667H7.61111V2.58333H8.58333V1.61111H9.41667V2.58333H10.3889V3.41667H9.41667V4.38889Z"
        fill="white"
      />
    </svg>
  )
}

export const OfficeIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props
  return (
    <svg
      width={size + Math.ceil(size / 9)}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.625 0C2.0382 0 1.5625 0.477563 1.5625 1.06667V14.9339H7.9375V11.2005H10.0625V14.9339H16.4375V1.06667C16.4375 0.477563 15.9618 0 15.375 0H2.625ZM3.6875 2.13385H5.8125V4.26719H3.6875V2.13385ZM7.9375 2.13385H10.0625V4.26719H7.9375V2.13385ZM12.1875 2.13385H14.3125V4.26719H12.1875V2.13385ZM3.6875 6.40052H5.8125V8.53385H3.6875V6.40052ZM7.9375 6.40052H10.0625V8.53385H7.9375V6.40052ZM12.1875 6.40052H14.3125V8.53385H12.1875V6.40052ZM3.6875 10.6672H5.8125V12.8005H3.6875V10.6672ZM12.1875 10.6672H14.3125V12.8005H12.1875V10.6672Z"
        fill={fill}
      />
      <path
        d="M0.5 16C0.5 15.4109 0.975697 14.9339 1.5625 14.9339H16.4375C17.0243 14.9339 17.5 15.4109 17.5 16H0.5Z"
        fill={fill}
      />
    </svg>
  )
}

export const RetailIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props

  return (
    <svg
      width={size + Math.ceil(size / 9)}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.7978 12.8C4.9178 12.8 4.2058 13.52 4.2058 14.4C4.2058 15.28 4.9178 16 5.7978 16C6.6778 16 7.3978 15.28 7.3978 14.4C7.3978 13.52 6.6778 12.8 5.7978 12.8ZM0.997803 0.800001C0.997803 1.24 1.3578 1.6 1.7978 1.6H2.5978L5.4778 7.672L4.3978 9.624C3.8138 10.696 4.5818 12 5.7978 12H14.5978C15.0378 12 15.3978 11.64 15.3978 11.2C15.3978 10.76 15.0378 10.4 14.5978 10.4H5.7978L6.6778 8.8H12.6378C13.2378 8.8 13.7658 8.472 14.0378 7.976L16.9018 2.784C16.9692 2.66274 17.0038 2.52598 17.0021 2.38724C17.0005 2.24851 16.9626 2.11262 16.8923 1.99301C16.822 1.8734 16.7217 1.77423 16.6013 1.7053C16.4809 1.63636 16.3445 1.60007 16.2058 1.6H4.3658L3.8298 0.456001C3.76551 0.319446 3.66364 0.204033 3.53613 0.123276C3.40862 0.042518 3.26074 -0.000242289 3.1098 1.03268e-06H1.7978C1.3578 1.03268e-06 0.997803 0.360001 0.997803 0.800001ZM13.7978 12.8C12.9178 12.8 12.2058 13.52 12.2058 14.4C12.2058 15.28 12.9178 16 13.7978 16C14.6778 16 15.3978 15.28 15.3978 14.4C15.3978 13.52 14.6778 12.8 13.7978 12.8Z"
        fill={fill}
      />
    </svg>
  )
}

export const SpecialPurposeIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 16 } = props
  return (
    <svg
      width={Math.ceil((size * 7) / 8)}
      height={size}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00001 0C5.33354 0.00196598 3.73589 0.66484 2.55752 1.84321C1.37914 3.02159 0.716267 4.61924 0.714301 6.28571C0.712305 7.64756 1.15715 8.97245 1.98059 10.0571C1.98059 10.0571 2.15202 10.2829 2.18002 10.3154L7.00001 16L11.8223 10.3126C11.8474 10.2823 12.0194 10.0571 12.0194 10.0571L12.02 10.0554C12.843 8.97121 13.2877 7.64693 13.2857 6.28571C13.2838 4.61924 12.6209 3.02159 11.4425 1.84321C10.2641 0.66484 8.66649 0.00196598 7.00001 0ZM9.05716 9.14286L7.00001 7.83371L4.94287 9.14286L5.28573 6.81486L3.57144 5.24171L5.97144 4.952L7.00001 2.85714L8.09259 4.95257L10.4286 5.24171L8.7143 6.81486L9.05716 9.14286Z"
        fill={fill}
      />
    </svg>
  )
}

export const MissingIcon = (props: PropertyTypeIconProps) => {
  const { fill = 'black', size = 28 } = props

  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 7H7V8.75H21V7ZM21.875 15.75V14L21 9.625H7L6.125 14V15.75H7V21H15.75V15.75H19.25V21H21V15.75H21.875ZM14 19.25H8.75V15.75H14V19.25Z"
        fill={fill}
      />
    </svg>
  )
}
